import Header from "../../../common/Header/Header";
import { useGetStrategy, useGetStrategyPackages } from "../../../services/strategy/strategy.service";
import { useParams } from "react-router-dom";
import { useFetchErrorToast } from "../../../utils/useFetchErrorToasts/useFetchErrorToast";
import { Form, FormElements } from "../../../common/AddEditFormLayout/AddEditFormLayout.styles";
import Input from "../../../components/Input/Input";
import { SubTitle } from "../../Classes/ClassForm/ClassForm.styles";
import { readOnlyLabelTableText } from "../../../constants/GlobalTexts";
import { TableWrapper } from "../../../common/TableWithButtonsAboveLayout/TableWithButtonsAboveLayout.styles";
import Table from "../../../components/Table/Table";
import Textarea from "../../../components/Textarea/Textarea";
import {
  InputWrapperLarge, InputWrapperMedium, InputWrapperSmall, RowWrapper, TextAreaWrapper
} from "./ViewStrategies.styles";

const ViewStrategy = () => {

  const { strategyNo } = useParams()

  const { data: getStrategyResponse, isError: getStrategyError } = useGetStrategy(strategyNo || '')
  useFetchErrorToast([
    {
      isError: getStrategyError,
      label: 'Error fetching strategy',
      id: 'strategyFetchError'
    }
  ]);
  const strategy = getStrategyResponse?.data

  const { data: getStrategyPackagesResponse, isError: getStrategyPackagesError } =
      useGetStrategyPackages(strategyNo || '');
  useFetchErrorToast([
    {
      isError: getStrategyPackagesError,
      label: 'Error fetching strategy packages',
      id: 'strategyPackageFetchError'
    }
  ]);
  const packages = getStrategyPackagesResponse?.data || []

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Strategies', to: '/tables/strategies' }}
            title={`View Strategy ${strategy?.strategyNo || ''} - ${strategy?.susLongDescription || ''}`}
            titleTestId={'ViewStrategyPageTitle'}
        />
        <Form>
          <FormElements>
            <RowWrapper>
              <InputWrapperMedium>
                <Input label="Strategy Number" id="strategyNo" value={strategy?.strategyNo} disabled/>
              </InputWrapperMedium>
              <InputWrapperMedium>
                <Input label="Description" id="description" value={strategy?.description} disabled/>
              </InputWrapperMedium>
              <InputWrapperSmall>
                <Input label="Mnemonic" id="mnemonic" value={strategy?.mnemonic} disabled/>
              </InputWrapperSmall>
              <InputWrapperSmall>
                <Input label="Type" id="type" value={strategy?.strategyTpCode} disabled/>
              </InputWrapperSmall>
            </RowWrapper>
            <RowWrapper>
              <InputWrapperLarge>
                <Input label="Sus Description" id="susDescription" value={strategy?.susLongDescription} disabled/>
              </InputWrapperLarge>
            </RowWrapper>
            <TextAreaWrapper>
              <Textarea label="Synopsis" id="synopsis" value={strategy?.synopsis} disabled/>
            </TextAreaWrapper>
            <RowWrapper>
              <InputWrapperMedium>
                <Input label="Concept" id="concept" value={strategy?.conceptNo.toString()} disabled/>
              </InputWrapperMedium>
              <InputWrapperMedium>
                <Input label="Occasion" id="occasion" value={strategy?.occasionNo.toString()} disabled/>
              </InputWrapperMedium>
            </RowWrapper>
            <TableWrapper>
              <Table
                  headerTitle={'Packages'}
                  width={'100%'}
                  showHeader={true}
                  rowData={packages}
                  returnedRecords={packages.length}
                  columnDefs={[
                    { initialWidth: 100, minWidth: 100, field: 'packageSequence', headerName: 'Sequence' },
                    { initialWidth: 250, minWidth: 150, field: 'description', headerName: 'Description' },
                    { initialWidth: 100, minWidth: 100, field: 'classNo', headerName: 'Class' },
                    { initialWidth: 100, minWidth: 100, field: 'baseNo', headerName: 'Base' },
                    { initialWidth: 100, minWidth: 100, field: 'sizeNo', headerName: 'Size' },
                    { initialWidth: 100, minWidth: 100, field: 'productNo', headerName: 'Product' },
                    { initialWidth: 120, minWidth: 120, field: 'freeToppings', headerName: 'Free Toppings' },
                    { initialWidth: 120, minWidth: 120, field: 'maxToppings', headerName: 'Max Toppings' },
                    { initialWidth: 100, minWidth: 100, field: 'quantity', headerName: 'Quantity' }
                  ]}
              />
            </TableWrapper>
          </FormElements>
        </Form>
        <SubTitle>{readOnlyLabelTableText}</SubTitle>
      </>
  )
}

export default ViewStrategy;